import styled from "styled-components";

export default styled.div`
  @media only screen and (max-width: 1280px) {
    max-width: 1100px;
  }
  @media only screen and (max-width: 1080px) {
    max-width: 936px;
  }
  max-width: 1250px;
  width: 100%;
  margin: 0 auto;
`;



// WEBPACK FOOTER //
// ./src/components/generic/layout/Container/index.js